import { render } from "./ProjectSnapDetail.vue?vue&type=template&id=54b84ede&scoped=true"
import script from "./ProjectSnapDetail.vue?vue&type=script&lang=js"
export * from "./ProjectSnapDetail.vue?vue&type=script&lang=js"

import "./ProjectSnapDetail.vue?vue&type=style&index=0&id=54b84ede&scoped=true&lang=scss"
import "./ProjectSnapDetail.vue?vue&type=style&index=1&id=54b84ede&lang=css"
import "./ProjectSnapDetail.vue?vue&type=style&index=2&id=54b84ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b84ede"]])

export default __exports__